import { CouponDTO, UserCouponDTO } from 'billing/dtos/coupon'
import { Model } from 'infra/model'
import { observable, makeObservable } from 'mobx'
import { maybeParseDate, DateZero } from 'utils/date-util'
import Coupon from './Coupon'
import { Id } from 'types/definitions'

export default class UserCoupon extends Model<UserCouponDTO, UserCoupon> {
  @observable userId = Id.none
  @observable workspaceId = Id.none
  @observable redeemed = false
  @observable dateCreated = DateZero()
  @observable dateRedeemed = DateZero()
  @observable coupon = Coupon.none

  constructor(private primeCoupon: (dto: CouponDTO) => Coupon) {
    super()
    makeObservable(this)
  }

  parse(attrs: Partial<UserCouponDTO>): Partial<UserCoupon> {
    return {
      redeemed: attrs.redeemed,
      userId: attrs.user_id,
      coupon: attrs.coupon && this.primeCoupon(attrs.coupon),
      workspaceId: attrs.coupon && attrs.coupon.workspace_id,
      dateCreated: maybeParseDate(attrs.date_created),
      dateRedeemed: maybeParseDate(attrs.date_redeemed),
    }
  }
}
